import React from 'react'

const Error = () => {
  return (
    <React.Fragment>
    <p>Error Pages</p>
    </React.Fragment>
  )
}

export default Error